module.exports = __webpack_public_path__ + "static/media/je.89207890.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/je.svg
// module id = 156
// module chunks = 0